import html2canvas from "html2canvas";

import xmlToJSON from "xmltojson";
import ReportsPreviewValueView from "./reports-preview-value.html";

declare global {
        interface String {
        equals(str: string): boolean;
    }
}

String.prototype.equals = function (str) {
    return this === str;
};

angular.module("reports")

    .directive('customOnChange', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                const onChangeHandler = scope.$eval(attrs.customOnChange);
                element.on('change', onChangeHandler);
                element.on('$destroy', function () {
                    element.off();
                });

            }
        };
    })

    .controller("ReportsPreviewCtrl", ['$sce', '$scope', 'LoginService', '$rootScope', '$state', 'Restangular', '$uibModal', 'modalService', '$filter', '$uibModalInstance', 'document', 'entity_type', 'entity_type_id', 'LanguagesService', 'logService',
        function ($sce, $scope, LoginService, $rootScope, $state, Restangular, $uibModal, modalService, $filter, $uibModalInstance, document, entity_type, entity_type_id, LanguagesService, logService) {

            $scope.allowWrite = LoginService.permissionExist("EVENTS_DOCUMENTS_PARAMETERS_WRITE");

            $scope.document = document;
            //$scope.event = event;

            $scope.jasper_parameters = {name: "JasperParameter", values: null};

            $rootScope.title = $filter('translate')('reports.title');
            $scope.reportJSON = {};

            $scope.documentConfig = null;
            $scope.parameters = [];

            //cargando valores configurados para el evento en cuestion
            let options = {
                entity_type: entity_type,
                entity_type_id: entity_type_id,
                document_id: $scope.document.id
            };

            $scope.jasperParameterValues = [];

            Restangular.all("DocumentsConfig").getList(options).then(function (response) {
                $scope.documentConfig = response;
                angular.forEach(response, function (parameter) {

                    if (parameter.name == null) {
                        $scope.jasper_parameters.values = parameter.values[0].value;
                        try {
                            if ($scope.jasper_parameters.values != null && $scope.jasper_parameters.values != "") {
                                let obj = JSON.parse($scope.jasper_parameters.values);

                                $scope.jasperParameterValues = [];
                                angular.forEach(obj.parameters, function (param) {
                                    $scope.jasperParameterValues[param.name] = param.value;
                                });
                            }
                        } catch (e) {
                            logService.error("Error parsing JSON for Jasper parameters: ", e);
                        }
                    }
                });

                
                Restangular.all("reports").customGET('previewjrxml/' + $scope.document.id).then(function (report) {
                    $scope.report = report;
                    $scope.parseJRXML($scope.report);
                });
            });


            $scope.editableParams = [];

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
            $scope.save = function () {
                $scope.parameters.push($scope.jasper_parameters);
                $uibModalInstance.close($scope.parameters);
            };

            $scope.getParameters = function (str) {
                const regex = /\$P{(.*?)}/gm;
                let m;

                const parameters = new Array();
                while ((m = regex.exec(str)) !== null) {
                    // This is necessary to avoid infinite loops with zero-width matches
                    if (m.index === regex.lastIndex) {
                        regex.lastIndex++;
                    }

                    // The result can be accessed through the `m`-variable.
                    m.forEach((match, groupIndex) => {
                        parameters.push(match);
                    });
                }
                return parameters;
            };

            $scope.getFirstParameter = function (str) {
                const parameters = $scope.getParameters(str);
                return parameters.length > 0 ? parameters[0] : null;
            };

            $scope.checkConditionalExpression = function (expression) {
                //No cogemos las condiciones $f{
                let check = "true";
                if (typeof (expression.text) === "string" && expression.text.indexOf("$P{") > -1 && expression.text.indexOf(".equals(") === 0) {
                    check = expression.text.replaceAll("\$P\{", "$scope.jasperParameterValues[\"").replaceAll("\}", "\"]");
                    check = expression.text.replaceAll("\$V\{", "[\"").replaceAll("\}", "\"]");
                    check = expression.text.replaceAll("\$F\{", "[\"").replaceAll("\}", "\"]");
                    check = expression.text.replaceAll("\$F\{", "[\"").replaceAll("\}", "\"]");
                }

                //Hacemos esta condicion, por que cuando es una expresion de java el eval peta
                if (expression.text.indexOf("Integer") > -1) {
                    return check;
                } else {
                    return eval(check);
                }
            };

            $scope.qrSampleBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALoAAAC6CAMAAAAu0KfDAAAABlBMVEX///8AAABVwtN+AAABxklEQVR4nO3QUZKDQAwD0eT+l94DgJQeCAXOtr4oGKzneb2MMebivHHSX31mbzljkC5d+hT6tj6dIcuQ+vRMDNKlS59I5zX9ZKKQ98QgXbr0X6X3f9P5NEG6dOnSSTGnk6/SpUv/PXrHEXpHHLsa6dKlT6cfq/nuMzdIly59Cv18SMGF9Wci/Y5IvyM301N9quxEshJZAy0sXbr0x9NJWRqXWH2NnnQR0qVLn0XvUL79KqVfFmmULl36FHpC9xBoByFi+ipduvQh9D4ivUllqwvwq5EuXfpEOjoK6NsJxy6iLyxduvRZ9M4lX8mSx7rieenSpQ+hry6z/TdVrl5E/1e6dOmz6H2B/kyI6TmtmhaLy0iXLv3B9FXWauXq5NSyE+nSpT+enupTyEoESto/oKVLl/54emKREemvPqf/tWCQLl36EHpfKYWc54vxLunSpU+hr2Zbn3Dkfb+yPkG6dOnPp79xTtWErmPXIV269Fn0nQ/hTHomK5FeflK6dOmz6O9N+Lgz6/XsoKVLl/6j9PS1V/LFert06dL/A31nUM13J0iXLn0inRfz9JnbM/3ipEuXPpF+DEGInN5bpEuXPpFujDEX5A/WVTvF1c+o+gAAAABJRU5ErkJggg==";

            $scope.parseJRXML = function (report) {
                let options: any = {
                    mergeCDATA: true,	// extract cdata and merge with text nodes
                    grokAttr: true,		// convert truthy attributes to boolean, etc
                    grokText: true,		// convert truthy text/attr to boolean, etc
                    normalize: true,	// collapse multiple spaces to single space
                    xmlns: false, 		// include namespaces as attributes in output
                    namespaceKey: '', 	// tag name for namespace objects
                    textKey: 'text', 	// tag name for text nodes
                    valueKey: 'value', 	// tag name for attribute values
                    attrKey: '', 	// tag for attr groups
                    cdataKey: '',	// tag for cdata nodes (ignored if mergeCDATA is true)
                    attrsAsObject: false, 	// if false, key is used as prefix to name, set prefix to '' to merge children and attrs.
                    stripAttrPrefix: false, 	// remove namespace prefixes from attributes
                    stripElemPrefix: true, 	// for elements of same name in diff namespaces, you can enable namespaces and access the nskey property
                    childrenAsArray: true 	// force children into arrays
                };
                $scope.reportJSON = xmlToJSON.parseString(report.xml, options);
                let report0 = $scope.reportJSON.jasperReport[0];

                //preparamos estilo documento
                $scope.pageStyle = {
                    "position": "relative",
                    "margin": "auto",
                    "background-color": "white",
                    "border": "1px solid #444444",
                    "-webkit-box-shadow": "0px 2px 5px 0px rgba(0,0,0,0.75)",
                    "-moz-box-shadow": "0px 2px 5px 0px rgba(0,0,0,0.75)",
                    "box-shadow": "0px 2px 5px 0px rgba(0,0,0,0.75)",
                    "width": report0.pageWidth.value + "px",
                    "height": report0.pageHeight.value + "px",
                    "padding-left": report0.leftMargin.value + "px",
                    "padding-top": report0.topMargin.value + "px",
                    "padding-right": report0.rightMargin.value + "px",
                    "padding-bottom": report0.bottomMargin.value + "px"
                };

                const leftMargin = parseFloat(report0.leftMargin.value);
                const topMargin = parseFloat(report0.topMargin.value);

                //extraemos elementos
                $scope.elements = [];
                const bands: any[] = [];
                
                $scope.editableParams = [];

                //Si tiene parametros los extraemos
                if (angular.isDefined(report0.parameter)) {
                    angular.forEach(report0.parameter, function (parameter) {
                        if(!$scope.jasperParameterValues[parameter.name.value] && parameter.defaultValueExpression) {
                            let val = parameter.defaultValueExpression[0].text;
                            if(typeof(val) === "string") {
                                val = val.replaceAll("\"", "");
                            }
                            $scope.jasperParameterValues[parameter.name.value] = val;
                        }

                        if(parameter.parameterDescription) {
                            $scope.editableParams.push({
                                name: parameter.name.value,
                                description: parameter.parameterDescription[0].text,
                                default: parameter.defaultValueExpression ? parameter.defaultValueExpression[0].text : "",
                            });
                        }
                    });
                }

                $scope.styles = [];
                $scope.styleClasses = [];
                // Generar los estilos
                if (angular.isDefined(report0.style)) {
                    $scope.styles = [];
                    angular.forEach(report0.style, function (style) {  
                        $scope.styles.push(style);
                    });
                    $scope.styles.forEach(function (style) {
                        if(style.conditionalStyle) {
                            angular.forEach(style.conditionalStyle, function (conditional) {
                                if(conditional.conditionExpression && conditional.style && $scope.checkConditionalExpression(conditional.conditionExpression[0])) {
                                    if(conditional.style[0].fontName) {
                                        style.fontName.value = conditional.style[0].fontName.value;
                                    }
                                    if(conditional.style[0].fontSize) {
                                        style.fontSize.value = conditional.style[0].fontSize.value;
                                    }
                                    if(conditional.style[0].hTextAlign) {
                                        style.hTextAlign = conditional.style[0].hTextAlign;
                                    }
                                }
                            });
                        }
                        let styleStr = ".ReportStyle-" + style.name.value + " {";
                        if (style.fontName) {
                            styleStr += "font-family: " + style.fontName.value + " !important;";
                        }
                        if (style.fontSize) {
                            styleStr += "font-size: " + style.fontSize.value + "pt !important;";
                        }
                        if(style.hTextAlign) {
                            styleStr += "text-align: " + style.hTextAlign.value + " !important;";
                        }
                        styleStr += "}";
                        $scope.styles.push(styleStr);

                        let styleClasses = GetStyleClasses(style);
                        $scope.styleClasses[style.name.value] = styleClasses;
                    });
                }
                
                if (angular.isDefined(report0.title)) bands.push(report0.title[0].band[0]);
                if (angular.isDefined(report0.summary)) bands.push(report0.summary[0].band[0]);
                if (angular.isDefined(report0.pageHeader)) bands.push(report0.pageHeader[0].band[0]);
                if (angular.isDefined(report0.columnHeader)) {
                    var aux = angular.copy(report0.columnHeader[0].band);

                    angular.forEach(report0.columnHeader[0].band, function (item, idx) {
                        angular.forEach(item.property, function (prop) {
                            if (prop.name.value == "diaple.show_band") {
                                if (prop.value.value == false) {
                                    var index = aux.indexOf(item);
                                    aux.splice(index, 1);
                                }
                            }
                        });
                    })
                    bands.push(aux[0]);
                }

                if (angular.isDefined(report0.detail)) {
                    
                    var aux = angular.copy(report0.detail[0].band[0]);
                                        
                    angular.forEach(report0.detail[0].band[0], function (item) {
                        angular.forEach(item.property, function (prop) {
                            if (prop.name.value == "diaple.show_band") {
                                if (prop.value.value == false) {
                                    var index = aux.indexOf(item);
                                    aux.splice(index, 1);
                                }
                            }
                        });
                    });

                    bands.push(aux);
                    //Si tiene dos detalles para dos paginas hay que cargarlo
                    if (report0.detail[0].band.length > 1) {
                        if (angular.isDefined(report0.detail)) {

                            var aux = angular.copy(report0.detail[0].band[1]);

                            angular.forEach(report0.detail[0].band[1], function (item) {
                                angular.forEach(item.property, function (prop) {
                                    if (prop.name.value == "diaple.show_band") {
                                        if (prop.value.value == false) {
                                            var index = aux.indexOf(item);
                                            aux.splice(index, 1);
                                        }
                                    }
                                });
                            });

                            bands.push(aux);
                        } 
                    }
                }

                if (angular.isDefined(report0.columnFooter)) bands.push(report0.columnFooter[0].band[0]);
                if (angular.isDefined(report0.pageFooter)) bands.push(report0.pageFooter[0].band[0]);
                if (angular.isDefined(report0.lastPageFooter)) bands.push(report0.lastPageFooter[0].band[0]);
                let heightUsed = 0;
                let cont = 0;
                
                angular.forEach(bands, function (band, typeIdx) {
                    logService.debug(band);

                    let existsElements = false;
                    if (typeof band != "undefined") {
                        $scope.elements.push({ band: cont + 1, elements: [] });
                        heightUsed = 0;
                        angular.forEach(band, function (type, typeIdx: string) {
                            if (typeIdx === "line") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    const style = "position: absolute;" +
                                        "background-color: #444444;" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;";
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: false,
                                        style: style,
                                    });
                                });
                            } else if (typeIdx === "rectangle") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    const style = "position: absolute;" +
                                        "background-color: " + (angular.isDefined(element.reportElement[0].backcolor) ? element.reportElement[0].backcolor.value : "transparent") + ";" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;";
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: false,
                                        style: style
                                    });
                                });
                            } else if (typeIdx === "staticText") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    let classes = " d-table-cell";
                                    if(element.reportElement[0].printWhenExpression) {
                                        if(!$scope.checkConditionalExpression(element.reportElement[0].printWhenExpression[0])) {
                                            classes = " d-none";
                                        }
                                    }
                                    if(element.reportElement[0].style) {
                                        classes += $scope.styleClasses[element.reportElement[0].style.value];
                                    }

                                    if(element.reportElement[0].positionType && element.reportElement[0].positionType.value === "Float") {
                                        classes += " position-float";
                                    }

                                    const style = "position: absolute;" +
                                        "background-color: " + (angular.isDefined(element.reportElement[0].backcolor) && angular.isDefined(element.reportElement[0].mode && element.reportElement[0].mode.value == "Opaque") ? element.reportElement[0].backcolor.value : "transparent") + ";" +
                                        (angular.isDefined(element.reportElement[0].forecolor) ? "color: " + element.reportElement[0].forecolor.value + ";" : "") +
                                        //(changeValue ? "cursor: pointer;" : "") +
                                        //"border: 1px dotted #e9e9e9;" +
                                        //"white-space: pre-line;" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;" +
                                        (Array.isArray(element.textElement[0].font) && angular.isDefined(element.textElement[0].font[0].size) ? "font-size: " + element.textElement[0].font[0].size.value + "px;" : "") +
                                        "line-height: normal;" +
                                        (angular.isDefined(element.textElement[0].rotation) ? "transform: rotate(" + (element.textElement[0].rotation.value == "UpsideDown" ? "180deg" : "") + ");" : "") +
                                        "text-align: " + element.textElement[0].textAlignment.value + ";" +
                                        "vertical-align: " + element.textElement[0].verticalAlignment.value + ";";
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: false,
                                        text: element.text[0].text,
                                        expression: "",
                                        style: style,
                                        classes: classes,
                                    });
                                });
                            } else if (typeIdx === "textField") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    let classes = " d-table-cell";
                                    if(element.reportElement[0].printWhenExpression) {
                                        if(!$scope.checkConditionalExpression(element.reportElement[0].printWhenExpression[0])) {
                                            classes = " d-none";
                                        }
                                    }
                                    if(element.reportElement[0].style) {
                                        classes += $scope.styleClasses[element.reportElement[0].style.value];
                                    } 

                                    if(element.reportElement[0].positionType && element.reportElement[0].positionType.value === "Float") {
                                        classes += " position-float";
                                    }

                                    let changeValue = (typeof element.textFieldExpression != "undefined" && element.textFieldExpression[0].text != null && element.textFieldExpression[0].text.indexOf("$P") == 0);
                                    const style = "position: absolute; font-size: 12pt;" +
                                        "background-color: " + (angular.isDefined(element.reportElement[0].backcolor) && angular.isDefined(element.reportElement[0].mode && element.reportElement[0].mode.value === "Opaque") ? element.reportElement[0].backcolor.value : "transparent") + ";" +
                                        (angular.isDefined(element.reportElement[0].forecolor) ? "color: " + element.reportElement[0].forecolor.value + ";" : "") +
                                        (changeValue ? "cursor: pointer;" : "") +
                                        (changeValue ? "border: 1px dotted #444444;" : "") +
                                        //"white-space: pre-line;" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;" +
                                        (Array.isArray(element.textElement[0].font) && angular.isDefined(element.textElement[0].font[0].size) ? "font-size: " + element.textElement[0].font[0].size.value + "px;" : "") +
                                        "line-height: normal;" +
                                        (Array.isArray(element.textElement[0].font) && angular.isDefined(element.textElement[0].font[0].isBold) ? "font-weight: " + (element.textElement[0].font[0].isBold.value ? "bold" : "normal") + ";" : "") +
                                        "overflow-wrap: break-word;" +
                                        (angular.isDefined(element.textElement[0].textAlignment) ? "text-align: " + element.textElement[0].textAlignment.value + ";" : "") +
                                        (angular.isDefined(element.textElement[0].rotation) ? "transform: rotate(" + (element.textElement[0].rotation.value == "UpsideDown" ? "180deg" : "") + ");" : "") +
                                        (angular.isDefined(element.textElement[0].verticalAlignment) ? "vertical-align: " + element.textElement[0].verticalAlignment.value + ";" : "");
                                    let text = "";
                                    let name = element.textFieldExpression[0].text;
                                    //busca propieda de valor por defecto
                                    if (angular.isDefined(element.reportElement[0].property)) {
                                        angular.forEach(element.reportElement[0].property, function (property) {
                                            if (property.name.value === "diaple.default_value") text = property.value.value;
                                            if (property.name.value === "diaple.parameter_name") {
                                                name = property.value.value;
                                                changeValue = true;
                                            }
                                        });
                                    }
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: changeValue,
                                        text: $sce.trustAsHtml(text),
                                        expression: name,
                                        style: style,
                                        classes: classes,
                                    });
                                });
                            } else if (typeIdx === "image") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    let classes = " d-table-cell";
                                    if(element.reportElement[0].printWhenExpression) {
                                        if(!$scope.checkConditionalExpression(element.reportElement[0].printWhenExpression[0])) {
                                            classes = " d-none";
                                        }
                                    }

                                    if(element.reportElement[0].positionType && element.reportElement[0].positionType.value === "Float") {
                                        classes += " position-float";
                                    }

                                    //extraemos parametros, si hay varios cogemos solo primero
                                    let parameterExpression = null;
                                    if (angular.isDefined(element.imageExpression)) {
                                        parameterExpression = $scope.getFirstParameter(element.imageExpression[0].text);
                                    }

                                    let backgroundSize = angular.isDefined(element.scaleImage) ? element.scaleImage.value : "cover";
                                    if (backgroundSize == "RetainShape") backgroundSize = "contain";
                                    if (backgroundSize == "FillFrame") backgroundSize = "cover";
                                    const changeValue = (typeof element.imageExpression != "undefined" && element.imageExpression[0].text != null && element.imageExpression[0].text.indexOf("$P{P_IMAGE") >= 0);
                                    const style = "position: absolute;" +
                                        "background-color: " + (angular.isDefined(element.reportElement[0].backcolor) && angular.isDefined(element.reportElement[0].mode && element.reportElement[0].mode.value == "Opaque") ? element.reportElement[0].backcolor.value : "transparent") + ";" +
                                        (changeValue ? "cursor: pointer;" : "") +
                                        "border: 1px dotted #444444;" +
                                        "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                        "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                        "width: " + element.reportElement[0].width.value + "px;" +
                                        "height: " + element.reportElement[0].height.value + "px;" +
                                        (angular.isDefined(element.hAlign) ? "text-align: " + element.hAlign.value + ";" : "") +
                                        (angular.isDefined(element.vAlign) ? "vertical-align: " + element.vAlign.value + ";" : "") +
                                        (angular.isDefined(element.imageExpression) && element.imageExpression[0].text.indexOf("?rotate") > 0 ? "transform: rotate(180deg);" : "") +
                                        "background-repeat: no-repeat;" +
                                        "background-position: center center;" +
                                        "background-image: url('/assets/img/no-image.png') !important;" +
                                        "background-size: " + backgroundSize + ";";
                                    $scope.elements[cont].elements.push({
                                        type: typeIdx,
                                        uuid: element.reportElement[0].uuid.value,
                                        changeValue: changeValue,
                                        text: "", //element.imageExpression[0].text,
                                        expression: parameterExpression, //element.imageExpression[0].text,
                                        style: style,
                                        size_info: element.reportElement[0].width.value + "x" + element.reportElement[0].height.value,
                                        classes: classes,
                                    });
                                });
                            } else if (typeIdx === "componentElement") {
                                existsElements = true;
                                angular.forEach(type, function (element, idx) {
                                    if (angular.isDefined(element.QRCode)) {
                                        let classes = " d-table-cell";
                                        if(element.reportElement[0].printWhenExpression) {
                                            if(!$scope.checkConditionalExpression(element.reportElement[0].printWhenExpression[0])) {
                                                classes = " d-none";
                                            }
                                        }

                                        if(element.reportElement[0].positionType && element.reportElement[0].positionType.value === "Float") {
                                            classes += " position-float";
                                        }

                                        //es un QR, ponemos ejemplo
                                        logService.debug(element);
                                        const style = "position: absolute;" +
                                            "left: " + (leftMargin + parseFloat(element.reportElement[0].x.value)) + "px;" +
                                            "top: " + (heightUsed + topMargin + parseFloat(element.reportElement[0].y.value)) + "px;" +
                                            "width: " + element.reportElement[0].width.value + "px;" +
                                            "height: " + element.reportElement[0].height.value + "px;" +
                                            (angular.isDefined(element.hAlign) ? "text-align: " + element.hAlign.value + ";" : "") +
                                            (angular.isDefined(element.vAlign) ? "vertical-align: " + element.vAlign.value + ";" : "") +
                                            (angular.isDefined(element.imageExpression) && element.imageExpression[0].text.indexOf("?rotate") > 0 ? "transform: rotate(180deg);" : "") +
                                            "background-repeat: no-repeat;" +
                                            "background-position: center center;" +
                                            "background-image: url(" + $scope.qrSampleBase64 + ");" +
                                            "background-size: contain;";
                                        $scope.elements[cont].elements.push({
                                            type: typeIdx,
                                            uuid: element.reportElement[0].uuid.value,
                                            changeValue: false,
                                            text: "",
                                            expression: "",
                                            style: style,
                                            classes: classes,
                                        });
                                    }
                                });
                            }
                        });
                        if (!existsElements) {
                            $scope.elements.splice(cont, 1);
                            cont--;
                        }
                        heightUsed += band.height.value;
                        cont++;
                    }
                    existsElements = false;
                });
                logService.debug($scope.elements);
                //evaluate expression
                //$scope.parameters = [];
                angular.forEach($scope.elements, function (band) {
                    angular.forEach(band.elements, function (element) {                       
                        if (element.changeValue) {
                            $scope.parameters.push({
                                name: element.expression,
                                value: ""
                            });
                        }
                    });
                });

                setTimeout(function () {
                    //hacemos captura para generar thumbnail de tipo de documento si no tiene ya
                    //html2canvas se ha actualizado a una nueva version, onrendered ha dejado de funcionar en la nueva

                    if (!report.has_thumbnail) {
                        /*html2canvas($("#jrxml-preview .page")[0], {
                            onrendered: function (canvas) {
                                var data = {
                                    document_id: $scope.doc_report.id,
                                    base64: canvas.toDataURL()
                                };
                                Restangular.all("documents").customPOST(data, 'thumbnail').then(function (result) {
                                    logService.debug(result);
                                });
                            }
                        });*/
                        $("#jrxml-preview .page").css("box-shadow", "");
                        html2canvas($("#jrxml-preview .page")[0], { scrollX: 0, scrollY: 0 }).then(canvas => {
                            const image = canvas.toDataURL("image/png", 1.0);
                            const data = {
                                document_id: $scope.document.id,
                                base64: image
                            };
                            Restangular.all("documents").customPOST(data, 'thumbnail').then(function (result) {
                                logService.debug(result);
                            });
                        });
                    }


                    let bands: HTMLElement[] = [];

                    angular.element(".band-element").each(function (index, element) {
                        bands.push(element);
                    });
                    bands.sort((a, b) => {
                        const aTop = parseFloat(a.style.top);
                        const bTop = parseFloat(b.style.top);
                        return aTop - bTop;
                    });

                    let heightIncr = 0;
                    bands.forEach(band => {
                        // If band has class d-none, skip it
                        if (!band.classList.contains("d-none")) {
                            let heightDiff = band.scrollHeight - parseInt(band.style.height.replace("px", ""));
                            if (heightDiff < 0) heightDiff = 0;
                            heightIncr += heightDiff;

                            if(heightDiff > 0) {
                                band.style.height = (parseInt(band.style.height.replace("px", "")) + heightDiff) + "px";
                            }

                            if(band.classList.contains("position-float")) {
                                band.style.top = (parseInt(band.style.top.replace("px", "")) + heightIncr) + "px";
                            }
                        }
                    });


                }, 1000);

                angular.forEach($scope.documentConfig, function (parameter) {
                    angular.forEach($scope.parameters, function (scopeParameter) {
                        if (scopeParameter.name == parameter.name) {
                            //scopeParameter.value = parameter.value;
                            angular.forEach($scope.elements, function (e) {
                                angular.forEach(e.elements, function (element) {
                                    if (element.expression == parameter.name) {
                                        element.values = parameter.values;
                                        angular.forEach(parameter.values, function (param) {
                                            scopeParameter.values = [];
                                            if (param.language_id == $rootScope.languageId) {
                                                if (element.type == "image") {
                                                    if (param.value != "") element.image_style = "background-image: url('" + param.value + "') !important;"; // background-size: contain !important;";
                                                    scopeParameter.values.push(param);
                                                } else {
                                                    element.text = $sce.trustAsHtml(param.value);
                                                    scopeParameter.values.push(param);
                                                }
                                            }
                                        });
                                    }
                                });
                            });
                        }
                    });
                });
            }

            $scope.enterValue = function (element,document_id) {
                if (element.changeValue) {
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: ReportsPreviewValueView,
                        controller: ['$scope', 'element', '$uibModalInstance', '$translate', '$timeout', function ($scope, element, $uibModalInstance, $translate, $timeout) {

                            $scope.element = element;

                            $scope.data = {
                                values: element.values
                            };

                            $scope.tinymceOptions = {
                                //resize: true,
                                language: $translate.use().toLowerCase(), //Hay que customizarlo dependiendo del idioma...
                                // language_url: "Scripts/tinymce/langs/es.js",
                                //min_height: 100,
                                contextmenu: false,
                                branding: false,
                                height: 200,
                                schema: "html5",
                                //relative_urls: false,
                                //remove_script_host: true,
                                formats: {
                                    bold: { inline: 'b' },
                                    underline: { inline: 'u' },
                                    italic: { inline: 'i' },
                                    alignleft: { selector: 'u,b,p,h1,h2,h3,h4,h5,h6,td,th,div,span', block: "div", styles: { "text-align": "left" } },
                                    aligncenter: { selector: 'u,b,p,h1,h2,h3,h4,h5,h6,td,th,div,span', block: "div", styles: { "text-align": "center" } },
                                    alignright: { selector: 'u,b,p,h1,h2,h3,h4,h5,h6,td,th,div,span', block: "div", styles: { "text-align": "right" } },
                                    alignjustify: { selector: 'u,b,p,h1,h2,h3,h4,h5,h6,td,th,div,span', block: "div", styles: { "text-align": "justify" } },
                                },
                                invalid_elements: 'strong,em',
                                fontsize_formats: "7pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 18pt 20pt 22pt 24pt 25pt 28pt 30pt 36pt 40pt 48pt 60pt",
                                // fontsize_formats: "7px 8px 9px 10px 11px 12px 13px 14px 15px 16px 18px 20px 22px 24px 25px 28px 30px 36px ",
                                // font_formats: 'Arial=Arial;Cambria=Cambria;Courier New=Courier New;Segoe Script=Segoe Script;Tahoma=Tahoma;Verdana=Verdana',
                                // body_class: 'custom_tinymce_content',
                                paste_as_text: true,
                                plugins: 'paste textcolor colorpicker',
                                //toolbar: "bold underline italic | fontsizeselect  forecolor | alignleft aligncenter alignright alignjustify | bullist numlist",
                                toolbar: "bold underline italic | fontsizeselect  forecolor | bullist numlist",
                                menubar: false,
                                forced_root_block: 'div',
                                /*forced_root_block_attrs: {
                                    'style': 'font-family: ' + font_family + '; font-size: ' + font_size

                                }*/
                            };


                            $scope.readFile = function (event) {
                                logService.debug("En readFile");
                                element.error = false;
                                let files = event.target.files;
                                let typeFile = "";
                                if (element.type == "image") {
                                    typeFile = "image";
                                }
                                Restangular.all("FilesTypesWhitelist").customGET("GetTotalSizeAllowed", { entity: "documents_config" }).then(function (result) {
                                    if (result.filter(e => e.type === files[0].type).length <= 0) {
                                        var typeAllowed = result.map(o => o.type).join(', ');
                                        modalService.message({
                                            title: "Error",
                                            message: $filter('translate')('general.type_file_not_allowed') + "<br>" + typeAllowed,
                                            onAccept: function () { }
                                        });
                                    } else {
                                        var maxSizeAllowed = result.find(e => e.type === files[0].type).maxsize;
                                        var sizeFileMB = files[0].size / 1024;
                                        if (sizeFileMB > 0) {
                                            //Comprobamos que no pase del tamaño limite de imagen
                                            if (sizeFileMB > maxSizeAllowed) {
                                                modalService.message({
                                                    title: "Error",
                                                    message: $filter('translate')('general.image_size_limit') + "<br>" + maxSizeAllowed + " Kb",
                                                    onAccept: function () { }
                                                });
                                            } else {
                                                let fileReader = new FileReader();
                                                $scope.data.values = [];
                                                fileReader.addEventListener("load", function (e) {
                                                    LanguagesService.languages().then(function (languages) {
                                                        angular.forEach(languages, function (language, idx) {
                                                            $scope.data.values.push({
                                                                language_id: language.id,
                                                                value: e.target.result
                                                            })
                                                        });
                                                    });
                                                });
                                                fileReader.readAsDataURL(files[0]);
                                            }
                                        }
                                    }
                                })

                            };

                            $scope.onCancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };
                            $scope.save = function () {
                                if (!element.error) {
                                    $uibModalInstance.close($scope.data);
                                }                                
                            };

                            $scope.removeElement = function () {
                                let options = {
                                    entity_type: entity_type,
                                    document_id: document_id,
                                    parameter_name: element.expression,
                                    entity_type_id: entity_type_id
                                };

                                Restangular.all('DocumentsConfig').customGET('getInfoDocumentConfig', options).then(function (result) {

                                    //result.remove().then(function () {
                                    //});
                                    element.image_style = null;
                                    element.text = null;
                                    $scope.data.values = null;

                                    if (!element.error) {
                                        $uibModalInstance.close($scope.data);
                                    }
                                });
                                
                            }
                        }],
                        resolve: {
                            element: function () {
                                return element;
                            }
                        }

                    });
                    $modalInstance.result.then(function (data) {
                        angular.forEach($scope.parameters, function (parameter) {
                            if (parameter.name == element.expression) {
                                parameter.values = data.values;
                                angular.forEach(data.values, function(param) {
                                    if(param.language_id == $rootScope.languageId) {
                                        if (element.type == "image") {
                                            if (param.value != "") element.image_style = "background-image: url('" + param.value + "') !important;"; // background-size: contain !important;";
                                        } else {
                                            element.text = $sce.trustAsHtml(param.value);
                                        }
                                    }
                                });
                            }
                        });
                    });
                }
            };

            $scope.onClearImages = function () {
                //Eliminamos las imagenes para que pueda cargar otras o dejarlo vacio
                let options = {
                    entity_type: entity_type,
                    document_id: $scope.document.id,
                    entity_type_id: entity_type_id
                };
                $scope.jasper_parameters.values = null;

                //Limpiamos todos los elementos para la bbdd
                angular.forEach($scope.parameters, function (param) {
                    if (param.values != null) {
                        param.values = null;
                    }
                });

                angular.forEach($scope.elements, function (e) {
                    angular.forEach(e.elements, function (element) {
                        if (element.type == "image") {
                            element.image_style = "background-image: url('/assets/img/no-image.png') !important;";
                        } else {
                            element.text = $sce.trustAsHtml(null);
                            element.values = [];
                        }
                    });
                });
            };

            function GetStyleClasses(style) {
                let className = " ReportStyle-" + style.name.value;;
                return className + " " + GetStyleClassesRec(style);
            }

            function GetStyleClassesRec(style) {
                if(style.style) {
                    let parentStyle = $scope.styles.find(function (s) {
                        return s.name.value == style.style.value;
                    });
                    if (parentStyle) {
                        let className = "ReportStyle-" + parentStyle.name.value;;
                        return className + " " + GetStyleClassesRec(parentStyle);
                    }
                }
                return "";
            }


        }
    ]);
